import { useQuery } from '@tanstack/react-query';

import { apiClient, ApiError } from '@/lib/api-client';

export interface HealthCheckResponse {
  status: string;
  timestamp: string;
  responseTime?: number;
  environment?: string;
  version?: string;
  checks?: {
    database?: { status: string; responseTime?: number };
    redis?: { status: string; responseTime?: number };
    emailQueue?: { status: string };
  };
}

export function useBackendHealth(refetchInterval = 60_000) {
  return useQuery<HealthCheckResponse, ApiError>({
    queryKey: ['backend-health'],
    queryFn: () => apiClient.get<HealthCheckResponse>('/api/v1/health'),
    refetchInterval,
    refetchOnWindowFocus: false,
    // Retry 3 times with exponential backoff before declaring the backend unreachable.
    // Without this, a single slow response on page load triggers the error banner.
    retry: 3,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10_000),
    staleTime: 30_000,
  });
}
